import React from 'react'
import { Box, Container, Typography } from '@material-ui/core'
import QuestionsList from '../Molecules/QuestionsList'
import { useSelector } from 'react-redux'
import Dropzone from '../Molecules/Dropzone'
import { useDrop } from 'react-dnd'
import DnDItemTypes from '../../features/dnd/DnDItemTypes'
import store from '../../store'
import { CLONE } from '../../features/State Management/questionsSlice'

export const QuestionsArea = () => {
  const questions = useSelector((state) => state.questions)
  const questionsLength = questions.length

  const [{ canDrop }, drop] = useDrop(
    () => ({
      accept: [DnDItemTypes.QUESTION_TYPE],
      drop: (item) => {
        store.dispatch(
          CLONE({
            source: item.label,
            destination: {
              target: null, // Null because we are targeting the root level of questions
              index: questionsLength,
            },
          })
        )
      },
      collect: (monitor) => ({
        canDrop: monitor.canDrop(),
      }),
    }),
    [questionsLength]
  )

  return (
    <Container style={{ textAlign: 'center' }} maxWidth='md'>
      <Typography variant='h4' style={{ margin: '1em 0' }}>
        Questions
      </Typography>
      <Box id={'dropzone'}>
        {questions.map((question, index) => (
          <QuestionsList index={index} key={question.id} question={question} />
        ))}
        <Dropzone canDrop={canDrop} dropRef={drop} />
      </Box>
    </Container>
  )
}
